import { postJSON } from "../utils/http.js"

export function getNotification(params) {
  return postJSON("/api/pigeon/blacklist", params, { loading: true })
}

export function setNotification(params) {
  return postJSON("/api/pigeon/blacklist/update", params, { loading: true })
}

export async function closeAPPAndSMSNotification(phoneNum) {
  const params = {
    edit: 2,
    phoneNum
  }

  const NEED_OPEN_TYPE = [2, 5]
  const primises = NEED_OPEN_TYPE.map(type => {
    return setNotification({ param: { ...params, blacklistType: type } })
  })
  await Promise.all(primises)
}
